import { cn } from '@nwwp/ui-shadcn'
import { fmtCompact, fmtDollars } from './format'
import type { CalculatorResults } from './types'

interface HowItWorksProps {
  results: CalculatorResults
}

export function HowItWorks({ results }: HowItWorksProps) {
  const rows = [
    { label: 'Monthly budget at retirement', value: `${fmtDollars(results.monthlyBudget)}/mo` },
    { label: 'Other income at retirement (inflation-adjusted)', value: `${fmtDollars(results.otherAtRet)}/mo` },
    { label: 'Needed from savings per month', value: `${fmtDollars(results.monthlyGapAtRet)}/mo` },
    { label: 'Portfolio needed at retirement', value: fmtCompact(results.whatYouNeed) },
    { label: 'Your projected portfolio', value: fmtCompact(results.whatYouHave), emphasis: true },
  ]

  return (
    <section aria-labelledby="ontrack-how-heading" className="rounded-3xl border border-smoke bg-white p-5 tablet:p-8">
      <h2 id="ontrack-how-heading" className="text-title-xs text-charcoal">
        How it works
      </h2>
      <dl className="mt-4">
        {rows.map((row) => (
          <div
            key={row.label}
            className="flex items-baseline justify-between gap-6 border-b border-frost py-3 last:border-b-0"
          >
            <dt className="text-body-sm text-neutral-darker">{row.label}</dt>
            <dd
              className={cn(
                'shrink-0 text-body-sm-bold tabular-nums',
                row.emphasis && results.ratio >= 1 ? 'text-green-positive' : 'text-charcoal'
              )}
            >
              {row.value}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  )
}
